import { combineReducers } from 'redux'
import { IState } from '../models/state'
import { client } from './client'

export const reducers = combineReducers<IState>({
	client
})